var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Small_Icons",
    "data-name": "Small Icons",
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n        stroke: #fff;\n        stroke-linecap: round;\n        stroke-width: 3px;\n      }\n\n      .cls-1, .cls-2 {\n        fill-rule: evenodd;\n      }\n\n      .cls-2 {\n        fill: #fff;\n        opacity: 0.25;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Email"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rounded_Rectangle_16",
    "data-name": "Rounded Rectangle 16",
    className: "cls-1",
    d: "M6.408,10.5H43.592a3,3,0,0,1,3,3v24a3,3,0,0,1-3,3H6.408a3,3,0,0,1-3-3v-24A3,3,0,0,1,6.408,10.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M4,32l43-5V38l-4,3L4,40V32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M4,16s10.959,6.22,15,8a13.8,13.8,0,0,0,12,0c4.228-1.878,15-8,15-8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.c149055da26b8108e107608e582d6f43.svg";
export { ForwardRef as ReactComponent };